import { useFormApi } from '@data-driven-forms/react-form-renderer';
import { ChildrenWidget } from 'lib-node-amb-renderer';

import Box from '~/common/components/Box';
import GenericTooltip from '~/common/components/GenericTooltip';
import { Table, Tbody, Th, Thead, Tr } from '~/common/components/Tables';

import type { TableHeader } from './index';

export class KYLTableClass extends ChildrenWidget {
  constructor(props) {
    super(props);
  }
}

type KYLTableProps = {
  fields?: any[];
  index?: number;
  thStyle?: any;
  doesTBodyScroll?: boolean;
  tbodyMaxHeight?: string;
  tableHeader?: TableHeader[];
};

export default function KYLTable({
  tableHeader,
  fields,
  tbodyMaxHeight,
}: Readonly<KYLTableProps>) {
  const { renderForm } = useFormApi();
  const totalCols = tableHeader.reduce((acc, cur) => acc + cur.colSpan, 0);
  return (
    <Box
      sx={{
        borderRadius: '4px',
        marginBottom: '18px',
        border: '1px solid #979797 !important',
        background: 'none !important',
        maxHeight: tbodyMaxHeight,
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          width: '6px',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
          border: 'none !important',
          backgroundColor: '#575957 !important',
        },
      }}
    >
      <Table sx={{ background: 'none !important' }}>
        <colgroup>
          {Array.from({ length: totalCols }, (_, index) => (
            <col key={index} width={`${100 / totalCols}%`}></col>
          ))}
        </colgroup>
        <Thead sx={{ position: 'sticky', top: 0 }}>
          <Tr>
            {tableHeader.map(({ label, colSpan, helperText }, index) => (
              <Th
                key={label}
                colSpan={colSpan}
                sx={{
                  letterSpacing: 'none',
                  textTransform: 'none !important',
                  color: 'black !important',
                  fontSize: '0.875rem',
                  backgroundColor: 'lightgray !important',
                  borderBottom: '0 !important',
                  borderRight: '1px solid #979797 !important',
                  borderLeft: index === 0 ? undefined : '0px',

                  '&:first-of-type': {
                    borderLeft: '0 !important',
                    borderRadius: '4px 0 0 0',
                    paddingLeft: '1.875rem !important',
                  },

                  '&:last-of-type': {
                    borderRadius: '0 4px 0 0',
                    borderRight: 'none !important',
                  },
                }}
              >
                {label}
                {helperText && <GenericTooltip label={helperText} />}
              </Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {fields.map((field, index) => {
            field.headerCols = tableHeader;
            field.position = index;
            return renderForm([field]);
          })}
        </Tbody>
      </Table>
    </Box>
  );
}
